import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { SaversPartnerLocation } from '../../types';

export interface partnerLocationParams {
  customerKey: number;
}

export const getPartnerLocations = (params: partnerLocationParams) => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetBranchsByCustomer`,
    method: 'get',
    params,
  });
};

export type SaversPartnerLocationsResponse = SaversPartnerLocation[];

export const fetchPartnerLocations = async (params: partnerLocationParams): Promise<SaversPartnerLocationsResponse> => {
  const response: AxiosResponse<SaversPartnerLocationsResponse> = await getPartnerLocations(params);
  return response.data;
};
